import {IBlock} from '../../../../models';
import {ExportType} from './constants';

const FILE_TYPES = [ExportType.CSV, ExportType.XLSX, ExportType.PNG];

export const getExportOptionsFromBlock = (block: IBlock | null) => {
  const defaultExportOptions = null;

  if (!block) {
    return defaultExportOptions;
  }

  return block.content_json?.export_options || defaultExportOptions;
}

export const getNameFromExportOptions = (exportOptions: any, blockName: string): string => {
  if (!exportOptions) {
    return blockName;
  }

  const type = exportOptions?.type || '';
  const fileName = exportOptions?.filename || '';
  let name: string = fileName || blockName;
  let extension: string = '';

  if (!type) {
    return name;
  }

  if (FILE_TYPES.includes(type)) {
    extension = '.' + type.toLowerCase();
  }

  return name + extension;
}
